import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import SubNavbar from "./global/SubNavbar";
import Navbar from "./global/Navbar";
import Footer from "./global/Footer";
import { SignIn } from "./pages/SignIn";
import { SignUp } from "./pages/SignUp";
import GuestDashboard from "./pages/GuestDashboard";
import Deatils from "./pages/Deatils";
import Course from "./pages/Course";
import BookStore from "./pages/BookStore";
import BookDetails from "./pages/BookDetails";
import Test from "./pages/Test";
import HomeBannerDetails from "./pages/HomeBannerDetails";
import About from "./pages/About";
import SmartSchool from "./components/Home/SmartSchool";
import TestLearning from "./pages/TestLearning";

import {initFacebookPixel } from "./utils/fbpixel";
import PixelTracker from "./utils/PixelTracker";
import ScrollToTop from "./global/ScrollToTop";
import Events from "./pages/Events";
import PrivateRoute from "./global/PrivateRoute";
import PublicRoute from "./global/PublicRoute";

const App = () => {
  useEffect(() => {
    initFacebookPixel("1115710150354833");
  }, []);

  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        {/* <HelmetMeta/> */}
        <PixelTracker />


        {/* <SubNavbar/> */}

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/qs-academy/home/details" element={<HomeBannerDetails />}/>
          <Route path="/qs-academy/about/" element={<About />} />
          <Route path="/qs-academy/smart-school/" element={<SmartSchool />} />
          <Route path="/qs-academy/test-learning/:name" element={<TestLearning />}/>
          <Route path="/qs-academy/test/:name" element={<Test />} />
         
          <Route path="/qs-academy/course/" element={<Course />} />
          <Route path="/qs-academy/course/details/:id" element={<Deatils />} />
          <Route path="/qs-academy/bookstore/" element={<BookStore />} />
          <Route path="/qs-academy/bookstore/:id" element={<BookDetails />} />
          <Route path="/qs-academy/events/" element={<Events />} />

          {/* <Route path="/qs-academy/mentors/" element={<Mentor />} />
          <Route path="/qs-academy/communication/" element={<Communication />}/> */}
       


          {/* Guest Dashboard (Private) */}
            <Route path="/qs-academy/guest/" element={<PrivateRoute><GuestDashboard /></PrivateRoute>}/>

            {/*Auth pages (Public only if not logged in) */}
            <Route path="/signin/" element={<PublicRoute><SignIn /></PublicRoute>}/>
            <Route path="/signup" element={<PublicRoute><SignUp /></PublicRoute>}/>

        </Routes>
        <Footer />
      </BrowserRouter>
    </>
  );
};

export default App;
